import { render, staticRenderFns } from "./ProductsTableListEditAvailability.vue?vue&type=template&id=6d080a0b&"
import script from "./ProductsTableListEditAvailability.vue?vue&type=script&lang=js&"
export * from "./ProductsTableListEditAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports